import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NewsletterModal from './components/NewsletterModal';
import OrderModal from './components/OrderModal';
import PickupModal from './components/PickupModal';
import { CartProvider } from './context/CartContext';
import { ContentProvider } from './context/ContentContext';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import MenuPage from './pages/Menu';
import Cafe from './pages/Cafe';
import WhereToBuy from './pages/WhereToBuy';
import Blog from './pages/Blog';
import Faq from './pages/Faq';
import Reviews from './pages/Reviews';
import AdminReviews from './pages/AdminReviews';
import Careers from './pages/Careers';
import Classes from './pages/Classes';
import Catering from './pages/Catering';
import GiftCards from './pages/GiftCards';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

function PublicLayout() {
  const [news, setNews] = useState(false);
  const [order, setOrder] = useState(false);
  const [pickup, setPickup] = useState(false);
  return (
    <>
      <Navbar onNewsletter={() => setNews(true)} onOrder={() => setOrder(true)} onPickup={() => setPickup(true)} />
      <main>
        <Routes>
          <Route path="/" element={<Home onNewsletter={() => setNews(true)} onOrder={() => setOrder(true)} onPickup={() => setPickup(true)} />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/cafe" element={<Cafe />} />
          <Route path="/where-to-buy" element={<WhereToBuy />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/catering" element={<Catering />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
        </Routes>
      </main>
      <Footer />
      <NewsletterModal open={news} onClose={() => setNews(false)} />
      <OrderModal open={order} onClose={() => setOrder(false)} />
      <PickupModal open={pickup} onClose={() => setPickup(false)} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/*" element={<PublicLayout />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </ContentProvider>
    </div>
  );
}

export default App;
